// eslint-disable-next-line import/no-cycle
import AuthService from "../../AuthService";

const TCDCMini = {
  getTCDCMini(page) {
    return AuthService.get(`/branch/tcdc_mini?page=${page}`);
  },
  showTCDCMini(id) {
    return AuthService.get(`/branch/tcdc_mini/${id}`);
  },
  createTCDCMini(data) {
    return AuthService.post("/branch/tcdc_mini", data);
  },
  updateTCDCMini(id, data) {
    return AuthService.put(`/branch/tcdc_mini/${id}`, data);
  },
  deleteTCDCMini(id) {
    return AuthService.delete(`/branch/tcdc_mini/${id}`);
  },
  getAllTCDCMini(){
    return AuthService.get(`/branch/get_all_mini`);
  },
  getMiniByBranchId(id){
    return AuthService.get(`/branch/get_mini_by_branch?branch_id=${id}`);
  },
};
export default TCDCMini;
